<template>
  <div>
    <ai-answer :full-fill-ment-text="fullFillMentText" :chat-theme-settings="chatThemeSettings"
      v-if="responseData?.botResponse?.component?.componentName !== 'tvm-startupbuttons'" />
    <div class="mx-lg-5">


      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-servicecoupons'
      ">
        <ai-service-coupons :design="design" :is-waiting-for-response="isWaitingForResponse"
          :count-coupons="responseData.countCoupons" :bot-response="responseData.botResponse"
          :is-last-index="isLastIndex" :index="index" />
      </template>

      <!-- color selection component -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'reservevehicle_colorcodes' &&
        isLastIndex
      ">
        <tvm-color-selection :is-new-design="true" :is-waiting-for-response="isWaitingForResponse"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end color selection component -->

      <!-- tvm-reserve-your-vehicle-final-view -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'reservevehicle_finalview'
      ">
        <tvm-reserve-your-vehicle-final-view :bot-response="responseData.botResponse" :is-new-design="true" />
      </template>
      <!-- end tvm-reserve-your-vehicle-final-view -->

      <!-- navigate to inventory -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'findavehicle_navigation'
      ">
        <tvm-navigate-to-inventory :is-new-design="true" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end navigate to inventory -->

      <!-- ai-start-up-buttons -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-startupbuttons'
      ">
        <ai-start-up-buttons :chat-theme-settings="chatThemeSettings" :interceptor-name="responseData.interceptorName"
          :is-waiting-for-response="isWaitingForResponse" :bot-response="responseData.botResponse"
          :is-last-index="isLastIndex" />
      </template>
      <!--end ai-start-up-buttons -->

      <!-- tvm-my-vehicles-->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-my-vehicles' &&
        isLastIndex
      ">
        <tvm-my-vehicles :is-new-design="true" :bot-response="responseData.botResponse" :is-last-index="isLastIndex" />
      </template>
      <!-- end tvm-my-vehicles-->

      <!-- tvm-login-vehicles-->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-login-vehicles' &&
        isLastIndex
      ">
        <tvm-login-vehicles :bot-response="responseData.botResponse" :is-last-index="isLastIndex" />
      </template>
      <!-- end tvm-login-vehicles-->

      <!-- tvm-schedule-service-types -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-scheduleservice-types'
      ">
        <tvm-service-types :is-new-design="true" :chat-theme-settings="chatThemeSettings"
          :is-waiting-for-response="isWaitingForResponse" :bot-response="responseData.botResponse"
          :is-last-index="isLastIndex" />
      </template>
      <!--end tvm-schedule-service-types -->

      <!-- tvm-service-offers -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-scheduleservice-offers'
      ">
        <tvm-service-offers :is-new-design="true" :chat-theme-settings="chatThemeSettings"
          :is-waiting-for-response="isWaitingForResponse" :bot-response="responseData.botResponse"
          :is-last-index="isLastIndex" />
      </template>
      <!--end tvm-service-offers -->


      <!-- tvm-dealer-special-offers -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-dealer-specials-offers'
      ">
        <tvm-dealer-special-offers :is-new-design="true" :is-waiting-for-response="isWaitingForResponse"
          :bot-response="responseData.botResponse" :is-last-index="isLastIndex" />
      </template>
      <!--end tvm-dealer-special-offers -->

      <!-- tvm-my-address -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-my-address'
      ">
        <tvm-my-address :chat-theme-settings="chatThemeSettings" :bot-response="responseData.botResponse"
          :is-last-index="isLastIndex" />
      </template>
      <!-- end tvm-my-address -->

      <!-- start tvm-show-color-swatches -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-show-color-swatches'
      ">
        <tvm-show-color-swatches :is-waiting-for-response="isWaitingForResponse"
          :bot-response="responseData.botResponse" :is-last-index="isLastIndex"
          :chat-theme-settings="chatThemeSettings" />
      </template>
      <!-- end tvm-show-color-swatches -->

      <!-- start tvm-trims -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-trim-component'
      ">
        <tvm-trims :bot-response="responseData.botResponse" :is-last-index="isLastIndex"
          :chat-theme-settings="chatThemeSettings" />
      </template>
      <!-- end tvm-trims -->

      <!-- start tvm-vehicleprice-component -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-vehicleprice-component'
      ">
        <tvm-vehicle-info :bot-response="responseData.botResponse" :is-last-index="isLastIndex"
          :chat-theme-settings="chatThemeSettings" />
      </template>
      <!-- end tvm-vehicleprice-component -->

      <!-- tvm-multi-select-suggestions -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component && isLastIndex &&
        responseData.botResponse.component.componentName === 'tvm-multi-select-component'
      ">
        <tvm-multi-select-suggestions class="ai_new_design" :chat-theme-settings="chatThemeSettings"
          :is-waiting-for-response="isWaitingForResponse" :bot-response="responseData.botResponse"
          :is-last-index="isLastIndex" :is-new-design="true" />
      </template>
      <!-- end tvm-multi-select-suggestions- -->

      <!-- start tvm-transport-types -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-transport-types' &&
        isLastIndex
      ">
        <tvm-transport-types :is-new-design="true" :is-waiting-for-response="isWaitingForResponse"
          :bot-response="responseData.botResponse" :is-last-index="isLastIndex"
          :chat-theme-settings="chatThemeSettings" />
      </template>
      <!-- end tvm-transport-types -->

      <!-- tvm-webredirect-component -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-webredirect-component'
      ">
        <tvm-webredirect-component :chat-theme-settings="chatThemeSettings" :bot-response="responseData.botResponse"
          :is-direct="responseData.isDirect" />
      </template>
      <!-- end tvm-webredirect-component -->


      <!-- tvm-sell-us-your-car -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'user_confirmation'
      ">
        <tvm-sell-us-your-car :is-new-design="true" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-sell-us-your-car -->

      <!-- tvm-kbb-trade-value -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm_kbb_trade_value'
      ">
        <tvm-kbb-trade-value :chat-theme-settings="chatThemeSettings" :index="index"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-kbb-trade-value -->

      <!-- tvm_bb_trade_value -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm_bb_trade_value'
      ">
        <tvm-bb-trade-value :chat-theme-settings="chatThemeSettings" :index="index"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm_bb_trade_value -->

      <!-- start tvm-body-styles -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-body-styles'
      ">
        <tvm-body-styles :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-body-styles -->

      <!-- start tvm-count-tiles -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-count-tiles'
      ">
        <tvm-count-tiles :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-count-tiles -->

      <!-- start tvm-count-tiles -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-model-images-component'
      ">
        <tvm-model-images-component :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-count-tiles -->

      <!-- start tvm-count-tiles -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-selected-model-image-component'
      ">
        <tvm-selected-model-image-component :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-count-tiles -->


      <!-- start tvm-count-tiles -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-textus-departments'
      ">
        <tvm-textus-departments :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-count-tiles -->

      <!-- start tvm-calender-component -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-calender-component' && isLastIndex
      ">
        <tvm-calender-component :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-calender-component -->


      <!-- start tvm-scheduleservice-radio-options -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component?.componentName === 'tvm-scheduleservice-radio-options'
      ">
        <tvm-scheduleservice-radio-options :is-last-index="isLastIndex" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-scheduleservice-radio-options -->

      <!-- suggestions -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.suggestions &&
        responseData.botResponse.suggestions.length &&
        isLastIndex
      ">
        <tvm-suggestions :is-new-design="true" :interceptor-name="responseData.interceptorName"
          :bot-response="responseData.botResponse" @tvm-suggestions="$emit('tvm-suggestions', $event)" />
      </template>
      <!-- end suggestions -->

      <!-- structured suggestions -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-structured-suggestions' &&
        isLastIndex
      ">
        <tvm-structured-suggestions :is-new-design="true" :is-waiting-for-response="isWaitingForResponse"
          :bot-response="responseData.botResponse" :chat-theme-settings="chatThemeSettings"
          @tvm-structured-suggestions="$emit('tvm-structured-suggestions', $event)" />
      </template>
      <!-- end structured suggestions -->


      <!-- start tvm-autocomplete-address -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-autocomplete-address' &&
        isLastIndex
      ">
        <tvm-autocomplete-address :search-text="userInputText" :selected-address-value="selectedAutoCompletedValue"
          :bot-response="responseData.botResponse" @selectedInputAddress="$emit('selectedInputAddress', $event)" />
      </template>
      <!-- end tvm-transport-types -->

      <!-- start tvm-ymmt-auto-complete -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-ymmt-auto-complete' &&
        isLastIndex
      ">
        <tvm-ymmt-auto-complete :search-text="userInputText" :selected-ymmt-value="selectedAutoCompletedValue"
          :bot-response="responseData.botResponse" @selectedInputYmmt="$emit('selectedInputYmmt', $event)" />
      </template>
      <!-- end tvm-ymmt-auto-complete -->

      <!-- tvm-page-redirect-component -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-page-redirect-component' &&
        isLastIndex &&
        responseData.isDirect
      ">
        <tvm-page-redirect-component :bot-response="responseData.botResponse" />
      </template>
      <!-- end tvm-page-redirect-component -->


      <!-- tvm-slideout-bb-tradevalue -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-slideout-bb-tradevalue'
        && responseData.botResponse.component.value
      ">
        <ai-bb-trade-value :response-data="responseData.botResponse.component.value" />
      </template>
      <!-- end tvm-slideout-bb-tradevalue -->

      <!-- tvm-slideout-kbb-tradevalue -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-slideout-kbb-tradevalue'
        && responseData.botResponse.component.value
      ">
        <ai-kbb-trade-value :response-data="responseData.botResponse.component.value" />
      </template>
      <!-- end tvm-slideout-bb-tradevalue -->

      <!-- start tvm-flow-end-items -->
      <div class="ai_new_design" v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm-flow-end-items'
      ">
        <tvm-flow-end-items :is-new-design="true" :chat-theme-settings="chatThemeSettings"
          :bot-response="responseData.botResponse" :is-last-index="isLastIndex" />
      </div>
      <!-- end tvm-flow-end-items -->

      <!-- tvm-multi-component -->
      <div v-if="
        responseData.botResponse &&
        responseData.botResponse.multiComponent &&
        responseData.botResponse.multiComponent.length &&
        isLastIndex
      ">
        <div v-for="(item, index) in responseData.botResponse.multiComponent" :key="index">
          <component :is="item.componentName.replaceAll('_', '-')"
            v-if="item?.componentName === 'tvm_signin_navigation' && responseData.isDirect"
            :bot-response="responseData.botResponse" :component-data="item" :is-last-index="isLastIndex" />

          <component class="ai_new_design" :is-new-design="true" :is="item.componentName"
            v-if="item?.componentName === 'tvm-user-feedback-prompt'" :id="conversationId"
            :bot-response="responseData.botResponse" :component-data="item" :is-last-index="isLastIndex"
            :feedbacks="itemData.feedbacks" :chat-theme-settings="chatThemeSettings" />

          <component :is="item?.componentName" v-if="item?.componentName === 'tvm-research-models-component'"
            :response-data="item.value" />

          <component :is="item?.componentName" v-if="item?.componentName === 'tvm-bvconfirmation-component'"
            :response-data="item.value" />

          <component class="ai_new_design_max" :is="item?.componentName"
            v-if="item?.componentName === 'tvm-suggestions'" :is-new-design="true"
            :is-waiting-for-response="isWaitingForResponse"
            :bot-response="getTvmSuggestionsResponse(item, responseData.botResponse)"
            @tvm-suggestions="$emit('tvm-suggestions', $event)" />
        </div>
      </div>
      <!-- end tvm-multi-component -->

      <!-- tvm_signin_navigation -->
      <template v-if="
        responseData.botResponse &&
        responseData.botResponse.component &&
        responseData.botResponse.component.componentName === 'tvm_signin_navigation' &&
        isLastIndex &&
        responseData.isDirect
      ">
        <tvm-sign-in-navigation :bot-response="responseData.botResponse" :is-last-index="isLastIndex"
          :component-data="responseData.botResponse?.component" />
      </template>
      <!-- end tvm_signin_navigation -->

    </div>

  </div>
</template>
<script>
import TvmAutoCompleteAddress from '../../TvmAutoCompleteAddress/TvmAutoCompleteAddress.vue';
import TvmDealerSpecials from '../../TvmDelaerSpecials/TvmDealerSpecials.vue';
import TvmFeedBack from '../../TvmFeedBack/TvmFeedBack.vue';
import TvmFlowEndItems from '../../TvmFlowEndItems/TvmFlowEndItems.vue';
import TvmMyVehicles from '../../TvmMyVehicles/TvmMyVehicles.vue';
import TvmPageRedirectComponent from '../../TvmPageRedirectComponent/TvmPageRedirectComponent.vue';
import TvmSellUsYourCar from '../../TvmSellUsYourCar/TvmSellUsYourCar.vue';
import TvmServiceOffers from '../../TvmServiceOffers/TvmServiceOffers.vue';
import TvmServiceTypes from '../../TvmServiceTypes/TvmServiceTypes.vue';
import TvmSignInNavigation from '../../TvmSignInNavigation/TvmSignInNavigation.vue';
import TvmStructuredSuggestions from '../../TvmStructuredSuggestions/TvmStructuredSuggestions.vue';
import TvmSuggestions from '../../TvmSuggestions/TvmSuggestions.vue';
import TvmTransportTypes from '../../TvmTransportTypes/TvmTransportTypes.vue';
import TvmYmmtAutoComplete from '../../TvmYmmtAutoComplete/TvmYmmtAutoComplete.vue';
import AiModelsCarousel from './AiModelsCarousel.vue';
import AiAnswer from './AiAnswer.vue';
import AiServiceCoupons from './AiServiceCoupons.vue';
import TvmColorSelection from '../../TvmColorSelection/TvmColorSelection.vue';
import TvmReserveYourVehicleFinalView from '../../TvmReserveYourVehicleFinalView/TvmReserveYourVehicleFinalView.vue';
import TvmNavigateToInventory from '../../TvmNavigateToInventory/TvmNavigateToInventory.vue';
import TvmKbbTradeValue from '../../TvmSellUsYourCar/TvmKbbTradeValue.vue';
import TvmBbTradeValue from '../../TvmSellUsYourCar/TvmBbTradeValue.vue';
import TvmMyAddress from '../../TvmMyAddress/TvmMyAddress.vue';
import TvmWebIframeRedirect from '../../TvmWebIframeRedirect/TvmWebIframeRedirect.vue';
import TvmLoginVehicles from '../../TvmLoginVehicles/TvmLoginVehicles.vue';
import TvmMultiSelectSuggestions from '../../TvmMultiSelectSuggestions/TvmMultiSelectSuggestions.vue';
import AiBbTradeValue from './AiBbTradeValue.vue';
import AiKbbTradeValue from './AiKbbTradeValue.vue';
import TvmStartUpButtons from '../../TvmStartUpButtons/TvmStartUpButtons.vue';
import AiStartUpButtons from './AiStartUpButtons.vue';
import AiBodyStyles from './AiBodyStyles.vue';
import AiCountTiles from './AiCountTiles.vue';
import AiModels from './AiModels.vue';
import AiSelectedModel from './AiSelectedModel.vue';
import AiTextUsDepartments from './AiTextUsDepartments.vue';
import AiColorSwatches from './AiColorSwatches.vue';
import AiTrims from './AiTrims.vue';
import AiVehicleInfo from './AiVehicleInfo.vue';
import AiCalendar from './AiCalendar.vue';
import TvmScheduleServiceOptions from './TvmScheduleServiceOptions.vue';
import TvmBvConfirmation from './TvmBvConfirmation.vue';

export default {
  components: {
    AiAnswer,
    TvmSuggestions,
    AiServiceCoupons,
    TvmMyVehicles,
    TvmServiceTypes,
    TvmStructuredSuggestions,
    TvmTransportTypes,
    TvmSellUsYourCar,
    TvmFlowEndItems,
    'tvm-signin-navigation': TvmSignInNavigation,
    AiStartUpButtons,
    'tvm-user-feedback-prompt': TvmFeedBack,
    'tvm-sign-in-navigation': TvmSignInNavigation,
    'tvm-page-redirect-component': TvmPageRedirectComponent,
    'tvm-autocomplete-address': TvmAutoCompleteAddress,
    'tvm-ymmt-auto-complete': TvmYmmtAutoComplete,
    'tvm-service-offers': TvmServiceOffers,
    'tvm-dealer-special-offers': TvmDealerSpecials,
    'tvm-research-models-component': AiModelsCarousel,
    'tvm-color-selection': TvmColorSelection,
    'tvm-reserve-your-vehicle-final-view': TvmReserveYourVehicleFinalView,
    'tvm-navigate-to-inventory': TvmNavigateToInventory,
    'tvm-kbb-trade-value': TvmKbbTradeValue,
    'tvm-bb-trade-value': TvmBbTradeValue,
    'tvm-my-address': TvmMyAddress,
    'tvm-show-color-swatches': AiColorSwatches,
    'tvm-webredirect-component': TvmWebIframeRedirect,
    'tvm-login-vehicles': TvmLoginVehicles,
    'tvm-multi-select-suggestions': TvmMultiSelectSuggestions,
    'ai-kbb-trade-value': AiKbbTradeValue,
    'ai-bb-trade-value': AiBbTradeValue,
    'tvm-start-up-buttons': TvmStartUpButtons,
    'tvm-body-styles': AiBodyStyles,
    'tvm-count-tiles': AiCountTiles,
    'tvm-model-images-component': AiModels,
    'tvm-selected-model-image-component': AiSelectedModel,
    'tvm-textus-departments': AiTextUsDepartments,
    'tvm-trims': AiTrims,
    'tvm-vehicle-info': AiVehicleInfo,
    'tvm-calender-component': AiCalendar,
    'tvm-scheduleservice-radio-options': TvmScheduleServiceOptions,
    'tvm-bvconfirmation-component': TvmBvConfirmation


  },
  props: {
    fullFillMentText: {
      required: false,
      default: '',
    },
    responseData: {
      required: false,
      default: '',
    },
    responseTime: {
      required: false,
      default: '',
    },
    request: {
      required: false,
      default: '',
    },
    isLastIndex: {
      required: false,
      default: '',
    },
    index: {
      required: false,
      default: null,
    },
    isWaitingForResponse: {
      required: false,
      default: null,
    },
    userInputText: {
      required: false,
      default: null,
    },
    selectedAutoCompletedValue: {
      required: false,
      default: false,
    },
    itemData: {
      required: false,
      default: null,
    },
    chatThemeSettings: {
      required: false,
      default: {}
    },
    design: {
      required: false,
      default: null
    },
    initialName: {
      required: false,
      type: String,
      default: '',
    },
  },
  methods: {
    getTvmSuggestionsResponse(item, botResponse) {
      return {
        suggestions: item.value,
        suggType: botResponse?.suggType ?? null,
      };
    },
  },
  computed: {
    conversationId() {
      if (this.responseData.id || this.itemData.id) {
        return this.responseData.id || this.itemData.id;
      }
    },
  },
}
</script>
<style>
.ai_new_design {
  max-width: 600px;
}

.ai_new_design_max {
  max-width: 700px;
}
</style>
